

















import {Component, Vue, Watch} from "vue-property-decorator";
import {AuthState, onAuthUIStateChange} from "@aws-amplify/ui-components";

@Component
export default class Login extends Vue {

    private unsubscribeAuth: any

    private authState: AuthState | null = null

    fields = [{type: 'email'}, {type: 'password'}]

    @Watch('authState')
    private onAuthStateChanged() {
        if (this.authState === AuthState.SignedIn) {
            this.$router.push({name: 'home'})
        }
    }

    private mounted() {
        this.unsubscribeAuth = onAuthUIStateChange(async (nextAuthState) => {
            this.authState = nextAuthState
        })
    }

    beforeDestroy() {
        this.unsubscribeAuth();
    }

}
